import {
    COMPANIES_FETCH,
    COMPANIES_IS_FETCING,
    COMPANY_FILTER,
    COMPANY_EDIT,
} from 'constants/companies'

export default function companiesReducer(state = {
    list: [],
    pageable: {
        sort: {
            'companyId': false,
            'name': 'asc',
            'email': false,
            'address': false,
            'description': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case COMPANIES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case COMPANY_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.companyId===e.companyId)?,
            }
        case COMPANIES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case COMPANY_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/companies.js